import { FormInstance, message, Modal } from 'antd';
import { seasonService } from 'content/service';
import { Dispatch, SetStateAction } from 'react';
import { PosterInterface } from 'type/seasonType';

interface PosterHandlersProps {
  form: FormInstance;
  seasonId: number;
  selectedPoster: PosterInterface | null;
  setSelectedPoster: (poster: PosterInterface | null) => void;
  setNewPosterList: (posterList: PosterInterface[]) => void;
  setUploadedPosterList: (posterList: PosterInterface[]) => void;
  removedUids: string[];
  setRemovedUids: Dispatch<SetStateAction<string[]>>;
}

interface PosterHandlers {
  handlePosterUpload: () => Promise<void>;
}

const handlePosterUpload = (props: PosterHandlersProps) => async (): Promise<void> => {
  const { form, seasonId } = props;
  const loadingMessage = message.loading('Creating...', 0);
  const posterList = form.getFieldValue('posterList');
  const newPosterList: PosterInterface[] = form.getFieldValue('newPosterList') || [];
  const uploadedPosterList: PosterInterface[] = form.getFieldValue('uploadedPosterList') || [];

  const allList = [...newPosterList, ...uploadedPosterList];
  const comboCounts = allList.reduce<Record<string, number>>((acc, t) => {
    const key = `${t.language}-${t.orientation}`;
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});
  const duplicates = Object.entries(comboCounts)
    .filter(([_, cnt]) => cnt > 1)
    .map(([combo]) => combo);

  if (duplicates.length > 0) {
    loadingMessage();
    Modal.error({
      title: 'Error',
      content: `Duplicate language/aspect ratio combination: ${duplicates.join(', ')}`,
      okText: 'Confirm',
    });
    return;
  }

  const removePosters = (posterList || []).filter(
    (uploadedPoster: { id: number }) =>
      !uploadedPosterList.some(
        (uploadPoster: { id: number }) => uploadPoster.id === uploadedPoster.id
      )
  );

  try {
    if (removePosters.length > 0) {
      await seasonService.removePoster(seasonId, removePosters);
    }
    if (newPosterList.length > 0) {
      await seasonService.uploadPoster(seasonId, newPosterList);
    }
    message.success('upload success');
    window.location.reload();
  } catch (error) {
    console.error('Failed to upload posters:', error);
  }
  loadingMessage();
};

const posterHandlers = (props: PosterHandlersProps): PosterHandlers => ({
  handlePosterUpload: handlePosterUpload(props),
});

export default posterHandlers;
